import { CSSProperties } from "react";

export interface ITradingBottomBarProps {
  style?: CSSProperties;
  showOnlyCurrentMarket: boolean;
  setShowOnlyCurrentMarket: (show: boolean) => void;
  onToggleCollapse?: () => void;
  collapsed?: boolean;
}

export enum MarketPortfolioOptionEnum {
  "Positions" = "Positions",
  "OpenOrders" = "Orders",
  // "Funding" = "Funding",
  "PositionHistory" = "Position History",
  "TradeHistory" = "Trade History",
  "OrderHistory" = "Order History",
  "Portfolio" = "Portfolio",
}

/**
 * URL slugs for the bottom-bar tabs. The enum values are display strings with
 * spaces, so they can't go in a query param as-is. Keep these stable — they are
 * part of shareable/bookmarkable URLs (`?panel=position-history`).
 */
export const MARKET_PORTFOLIO_TAB_SLUGS: Record<
  MarketPortfolioOptionEnum,
  string
> = {
  [MarketPortfolioOptionEnum.Positions]: "positions",
  [MarketPortfolioOptionEnum.OpenOrders]: "open-orders",
  [MarketPortfolioOptionEnum.PositionHistory]: "position-history",
  [MarketPortfolioOptionEnum.TradeHistory]: "trade-history",
  [MarketPortfolioOptionEnum.OrderHistory]: "order-history",
  [MarketPortfolioOptionEnum.Portfolio]: "portfolio",
};

export type MarketPortfolioOptionCount = {
  [key in MarketPortfolioOptionEnum]: number | undefined;
};
